/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
document.addEventListener("DOMContentLoaded", () => {

    window.renderAddOneGallery = function (productId, variantId, refs, title) {
      const template = document.querySelector(`.addone-media-template[data-product-id="${productId}"]`);
      const imageList = refs.imageList;
      const paginationList = refs.paginationImageList;
      imageList.innerHTML = "";
      paginationList.innerHTML = "";
  
      if (!template) return;
  
      const mediaBlock = template.content
        ? template.content.querySelector(`.addone-media-block[data-variant-id="${variantId}"]`)
        : template.querySelector(`.addone-media-block[data-variant-id="${variantId}"]`);
  
      if (mediaBlock) {
        const images = mediaBlock.querySelectorAll("img[src]");
        images.forEach(img => {
          const src = img.getAttribute("src");
          if (!src) return;
          const li = document.createElement("li");
          li.classList.add("swiper-slide");
          const image = document.createElement("img");
          image.src = src;
          image.alt = title || "";
          li.append(image);
          imageList.append(li);
          paginationList.append(li.cloneNode(true));
        });
      } else {
        const globalMedia = window[`addOneMedia${productId}`];
        if (Array.isArray(globalMedia)) {
          globalMedia
            .filter(item => item.media_type === "image" || item.preview_image)
            .forEach(item => {
              const src = item.preview_image ? item.preview_image.src : item.src;
              if (!src) return;
              const li = document.createElement("li");
              li.classList.add("swiper-slide");
              const image = document.createElement("img");
              image.src = src;
              image.alt = title || "";
              li.append(image);
              imageList.append(li);
              paginationList.append(li.cloneNode(true));
            });
        }
      }
  
      if (window.modalPaginationSlider) {
        window.modalPaginationSlider.destroy();
        window.modalPaginationSlider = null;
      }
      if (window.modalSwiper) {
        window.modalSwiper.destroy();
        window.modalSwiper = null;
      }
  
      window.modalPaginationSlider = new Swiper("#add--one--modal__image--slider_pagination", {
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 7,
        allowTouchMove: true,
        navigation: { nextEl: ".modal--slider--next", prevEl: ".modal--slider--prev" },
      });
  
      window.modalSwiper = new Swiper("#add--one--modal__image--slider", {
        loop: false,
        navigation: { nextEl: ".modal--slider--next", prevEl: ".modal--slider--prev" },
        thumbs: { swiper: window.modalPaginationSlider },
      });
    };
  
    window.addOneModalHandler = function () {
      const refs = {
        modal: document.getElementById("add--one--modal"),
        openers: document.querySelectorAll(".add-one__popup-opener"),
        closeBtn: document.querySelector("#add--one--modal .add--one--modal__close"),
        title: document.querySelector("#add--one--modal .add--one--modal__info--title"),
        raiting: document.querySelector("#add--one--modal .add--one--modal__info--raiting"),
        description: document.querySelector("#add--one--modal .add--one--modal__info--description"),
        imageList: document.querySelector("#add--one--modal .add--one--modal__image--list"),
        paginationImageList: document.querySelector("#add--one--modal .add--one--modal__image--list__pagination"),
        modalHandlersBox: document.querySelector("[is-addone-modal-handlers-box]"),
        modalColorPickerBox: document.querySelector("[is-addone-modal-colors]"),
        modalVariantPickerBox: document.querySelector("[is-addone-modal-variants]"),
        modalCheckbox: document.querySelector("[is-addone-modal-checkbox]"),
      };

      if (!refs.modal) return; 
  
      let modalSwiper;
      let modalPaginationSlider;
  
      function closeModal() {
        refs.modal.classList.toggle("open");
        refs.modalHandlersBox.classList.toggle("open");
        document.body.classList.toggle("modal--open");
        const chat = document.getElementById("tidio-chat-iframe");
        if (chat) chat.style.display = refs.modal.classList.contains("open") ? "none" : "block";
      }
  
      function onModalOpenerClick(event) {
        const container = event.currentTarget.closest(".upsells-cart-list__li");

        const variantItems = container.querySelectorAll(".complete_cart__variants .variant.type");
        const colorItemsAll = container.querySelectorAll(".complete_cart__variants .variant.color");

        refs.modalColorPickerBox.innerHTML = "";
        refs.modalVariantPickerBox.innerHTML = "";

        let colorItems = [];

        const activeTypeEl = container.querySelector('.variant.type.active');
        const activeType = activeTypeEl?.dataset.type?.trim() || activeTypeEl?.dataset.name?.trim();
        if (activeType) {
          colorItems = Array.from(container.querySelectorAll(`.complete_cart__variants .variant.color[data-name="${activeType}"]`));
        } else {
          colorItems = Array.from(colorItemsAll);
        }

        colorItems.forEach(item => {
          const innerLabel = item.querySelector(".variant__label");
          const span = innerLabel?.querySelector("span")?.cloneNode(true);
          if (!span) return;
          const wrapper = document.createElement("label");
          const radio = document.createElement("input");
          wrapper.classList.add("modal--color__label");
          radio.type = "radio";
          radio.name = "modal--color";
          if (innerLabel?.classList.contains("addone-color-label-out")) {
            wrapper.classList.add("addone-color-label-out");
            radio.disabled = true;
          }
          wrapper.append(radio, span);
          if (item.classList.contains("active")) {
            radio.checked = true;
            $(".add--one--modal__handler--button").data("variant", item.dataset.variant);
          }
          radio.addEventListener("change", () => {
            if (!innerLabel?.classList.contains("addone-color-label-out")) {
              $(".product-single__add-ons").attr("data-from-popup", "1");
              item.click();
              setTimeout(() => $(".product-single__add-ons").attr("data-from-popup", "0"), 1000);
            }
          });
          refs.modalColorPickerBox.append(wrapper);
        });

        variantItems.forEach(item => {
          const value = item.dataset.valueHandle || item.dataset.name;
          const tooltip = item.querySelector(".tooltip")?.outerHTML || "";
          const wrapper = document.createElement("label");
          wrapper.classList.add("modal--variant__label");
          wrapper.dataset.valueHandle = value;
          const radio = document.createElement("input");
          radio.type = "radio";
          radio.name = "modal--variant";
          if (item.classList.contains("addone-switcher-label-out")) {
            radio.disabled = true;
            wrapper.classList.add("addone-switcher-label-out");
          }
          const icon = item.querySelector(".variant__label-container")?.cloneNode(true);
          const content = document.createElement("div");
          content.classList.add("modal--variant__bubble");
          if (icon) content.append(icon);
          content.insertAdjacentHTML("beforeend", tooltip);
          wrapper.append(radio, content);
          if (item.classList.contains("active")) radio.checked = true;
          radio.addEventListener("change", () => {
            $(".product-single__add-ons").attr("data-from-popup", "1");
            item.click();
            setTimeout(() => $(".product-single__add-ons").attr("data-from-popup", "0"), 1000);
          });
          refs.modalVariantPickerBox.append(wrapper);
        });
  
        const { description, title, url, id } = container.dataset;
        const buttonText = $(".pdp_variables_for_popups").attr("data-more");
  
        refs.title.innerHTML = title;
        refs.description.innerHTML = `${description} <a href="${url}">${buttonText}</a>`;
        refs.raiting.innerHTML = "";
        refs.imageList.innerHTML = "";
        refs.paginationImageList.innerHTML = "";
  
        let activeVariantId = $(`.addOneVariantSelection.activeVariant[data-product-id="${id}"]`).attr("data-id");

        // Fallback: read from the active color div if hidden inputs aren't synced yet
        if (!activeVariantId) {
          activeVariantId = container.querySelector('.complete_cart__variants .variant.color.active')?.dataset.variant
            || container.querySelector('.complete_cart__variants .variant.active:not(.type)')?.dataset.variant;
        }

        if (window.renderAddOneGallery && activeVariantId) {
          window.renderAddOneGallery(id, activeVariantId, refs, title);
        } else {
          console.warn("Gallery not ready for:", id, "variant:", activeVariantId);
        }
  
        $(".add--one--modal__handlers").on("click", () => {
          if (modalSwiper) modalSwiper.slideTo(0, 0, false);
          $(".add--one--modal").scrollTop(0);
        });
  
        closeModal();
      }
  
      refs.modal.addEventListener("click", e => {
        if (e.target === e.currentTarget) closeModal();
      });
      refs.closeBtn.addEventListener("click", closeModal);
  
      $(".product__accordion-title, .product__accordion-triger").on("click", function () {
        const box = $(this).closest(".js--accordion--box");
        box.find(".product__accordion-wrapper").toggleClass("open");
        box.find(".product__accordion-triger").toggleClass("active");
        $(".wrapper-in .add--one--modal").toggleClass("popup_positioned_top");
      });
  
      refs.openers.forEach(opener => {
        opener.addEventListener("click", function (event) {
          onModalOpenerClick(event);
          const id = $(this).attr("data-product-id");
          $(".add--one--modal__content").attr("data-product-id", id);
        });
      });
  
      window.addOneModalRefs = refs;
    };
  
    window.addOneModalHandler();
  
    $(document).on("click", ".add--one--modal__handler--box", function () {
      var productId;
      var currentId;
      const color = $(".add--one--modal__handler--box[is-addone-modal-colors]").find(".modal--color__label.activelabel span").attr("data-color-handle");
      const size = $(".add--one--modal__handler--box[is-addone-modal-variants]").find(".modal--variant__label.activelabel").attr("data-value-handle");
      if (color && size) {
        const title = `${color}-${size}`;
        $(".addOneVariantSelection").removeClass("activeVariant");
        $(".addOneVariantSelection").each(function () {
          if ($(this).attr("data-variant-title") === title) {
            $(this).addClass("activeVariant");
            currentId = $(this).attr("data-id");
          }
        });
      } else if (color) {
        $(".addOneVariantSelection").removeClass("activeVariant");
        $(".addOneVariantSelection").each(function () {
          if ($(this).attr("data-variant-title") === color) {
            $(this).addClass("activeVariant");
            currentId = $(this).attr("data-id");
          }
        });
      }
      $(".add-one_media_loader").css("display", "flex").addClass("activated");
      setTimeout(function () {
        productId = $('.add--one--modal__content').attr('data-product-id');
        currentId = $(".addOneVariantSelection.activeVariant[data-product-id='" + productId + "']").attr("data-id");
        if (currentId && window.renderAddOneGallery && window.addOneModalRefs) {
          window.renderAddOneGallery(productId, currentId, window.addOneModalRefs, "");
          setTimeout(() => $(".add-one_media_loader").removeClass("activated"), 500);
          setTimeout(() => $(".add-one_media_loader").hide(), 1500);
        } else {
          console.warn("Gallery renderer not ready or missing variant ID:", currentId);
        }
        $("[is-addone-modal-checkbox]").attr("data-id", currentId);
        $(".add--one--modal__handler--button").data("variant", currentId);
      }, 200);
    });

  $(document).on("click", ".add--one--modal__handler--button", function () {
    var variantId = $(this).data("variant");
    if (variantId) window.cartDrawer?.addModalProduct(variantId);
  });
  });
